import { render } from "./Fail.vue?vue&type=template&id=43d3ae20&scoped=true"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"

import "./Fail.vue?vue&type=style&index=0&id=43d3ae20&scoped=true&lang=css"

import exportComponent from "/Users/ozgurozkankar/Desktop/validationPage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d3ae20"]])

export default __exports__